import { SelectField } from '@/components/forms/Field';
import type { ChildRef } from '@/types/portal';

/**
 * Which child a guardian is looking at. Only rendered when there is more than
 * one; the choice lives in the URL (`?child=`), so a link or a refresh keeps it.
 */
export function ChildSwitcher({
  items,
  value,
  onChange,
}: {
  items: ChildRef[];
  value: string | undefined;
  onChange: (studentId: string) => void;
}) {
  if (items.length < 2) {
    return null;
  }
  return (
    <div className="w-full min-w-0 sm:w-64">
      <SelectField
        id="portal-child"
        label="Child"
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value)}
      >
        {items.map((child) => (
          <option key={child.studentId} value={child.studentId}>
            {child.studentName}
            {child.sectionName !== undefined ? ` · ${child.sectionName}` : ''}
          </option>
        ))}
      </SelectField>
    </div>
  );
}
